export const giftCardEndpoints = (builder) => ({
    createGiftCard: builder.mutation({
        query: (data) => ({ url: `/gift-cards`, method: 'post', body: data }),
        invalidatesTags: ['Gift Cards'],
    }),
    updateGiftCard: builder.mutation({
        query: ({ id, meta, ...data }) => ({ url: `/gift-cards/${id}`, method: 'patch', body: { ...data, meta } }),
        invalidatesTags: ['Gift Cards'],
    }),
    cancelGiftCard: builder.mutation({
        query: ({ id, meta }) => ({ url: `/gift-cards/${id}`, method: 'delete', body: { meta } }),
        invalidatesTags: ['Gift Cards'],
    }),
})